module.exports = __webpack_public_path__ + "img/41.16a110e8.jpg";